import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const AdminContainer = styled.div`
  padding: 2rem;
  width: 100%;
  min-height: 100vh;
  background: var(--background);
  animation: ${fadeIn} 0.5s ease-out;
  box-sizing: border-box;

  header {
    margin-bottom: 2.5rem;
    h2 {
      font-size: 2rem;
      color: var(--text-main);
      font-weight: 800;
      margin: 0;
    }
    p {
      color: var(--text-secondary);
      margin-top: 4px;
    }
  }
`;

export const FormCard = styled.div`
  background: var(--surface);
  border-radius: 20px;
  padding: 24px;
  border: 1px solid var(--border);
  margin-bottom: 2rem;

  h3 {
    margin: 0 0 24px 0;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--text-main);
  }

  form {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    .input-group {
      display: flex;
      flex-direction: column;
      gap: 6px;
      label {
        font-size: 0.75rem;
        font-weight: 700;
        color: var(--text-secondary);
        text-transform: uppercase;
        display: flex;
        align-items: center;
      }
      input,
      select {
        padding: 12px;
        border-radius: 10px;
        border: 1px solid var(--border);
        background: var(--background);
        color: var(--text-main);
        &:focus {
          border-color: var(--primary);
          outline: none;
        }
      }
    }
    .full-width {
      grid-column: span 2;
    }
    .actions {
      display: flex;
      align-items: flex-end;
      gap: 10px;
      button {
        height: 45px;
        border-radius: 10px;
        cursor: pointer;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .save-btn {
        background: var(--secondary);
        color: white;
        border: none;
        flex: 1;
        &:disabled {
          opacity: 0.5;
        }
      }
      .cancel-btn {
        background: var(--background);
        border: 1px solid var(--border);
        color: var(--text-secondary);
        width: 45px;
      }
    }
  }

  @media (max-width: 1024px) {
    form {
      grid-template-columns: 1fr 1fr;
    }
  }
  @media (max-width: 600px) {
    form {
      grid-template-columns: 1fr;
      .full-width {
        grid-column: span 1;
      }
    }
  }
`;

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  .search-input,
  .category-filter {
    display: flex;
    align-items: center;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 10px;
    padding: 0 12px;
    height: 45px;
    input,
    select {
      border: none;
      background: transparent;
      color: var(--text-main);
      outline: none;
      width: 100%;
    }
    svg {
      color: var(--text-secondary);
      margin-right: 8px;
    }
  }
  .search-input {
    flex: 1;
    min-width: 200px;
  }
  .category-filter {
    min-width: 180px;
  }
  .results-count {
    font-size: 0.85rem;
    color: var(--text-secondary);
    font-weight: 600;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;

  thead th {
    padding: 8px 16px;
    color: var(--text-secondary);
    font-size: 0.75rem;
    text-transform: uppercase;
    text-align: left;
  }
  tbody tr {
    background: var(--surface);
    td {
      padding: 12px 16px;
      border-top: 1px solid var(--border);
      border-bottom: 1px solid var(--border);
      &:first-child {
        border-left: 1px solid var(--border);
        border-radius: 12px 0 0 12px;
      }
      &:last-child {
        border-right: 1px solid var(--border);
        border-radius: 0 12px 12px 0;
      }
      .badge {
        background: var(--background);
        padding: 4px 8px;
        border-radius: 6px;
        font-size: 0.7rem;
        font-weight: 700;
        border: 1px solid var(--border);
      }
      .price-text {
        font-weight: 800;
        color: var(--secondary);
      }
      .btn-actions {
        display: flex;
        gap: 8px;
        button {
          all: unset;
          cursor: pointer;
          width: 32px;
          height: 32px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid var(--border);
          transition: 0.2s;
          &:hover {
            background: var(--background);
            transform: translateY(-2px);
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    display: block;
    thead {
      display: none;
    }
    tbody {
      display: block;
      tr {
        display: block;
        margin-bottom: 12px;
        td {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: none !important;
          border-bottom: 1px solid var(--border) !important;
          &::before {
            content: attr(data-label);
            font-weight: 700;
            font-size: 0.7rem;
            color: var(--text-secondary);
          }
        }
      }
    }
  }
`;
